var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCastle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 121.71",
    style: {
      enableBackground: "new 0 0 122.88 121.71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    className: "st0",
    d: "M74.63,71.74l0.13-24.69l5.21-7.65l-0.12-8.21c0-0.23-0.19-0.42-0.42-0.42H63.31v-9.44l22-8.91l-22-8.83V1.74 c0-2.32-3.52-2.32-3.52,0v29.04H44.61c-0.23,0-0.42,0.19-0.42,0.42l-0.12,8.21l5.53,7.49v24.85h-6.49v-7.4H30.64l0.04-8.39 l5.21-7.65l-0.12-8.21c0-0.23-0.19-0.42-0.42-0.42H0.54c-0.23,0-0.42,0.19-0.42,0.42L0,48.3l5.53,7.49v65.92h24.69h0.12h20.12V96.5 c0-6.28,5.14-11.43,11.43-11.43h0c6.28,0,11.43,5.14,11.43,11.43v25.22h19.2h0.12h24.69l0.35-65.76l5.21-7.65l-0.12-8.21 c0-0.23-0.19-0.42-0.42-0.42H87.52c-0.23,0-0.42,0.19-0.42,0.42l-0.12,8.21l5.53,7.49v8.55H80.21v7.4H74.63L74.63,71.74z M62.02,38.75c2.59,0,4.69,2.1,4.69,4.69c0,2.59-2.1,4.69-4.69,4.69c-2.59,0-4.69-2.1-4.69-4.69 C57.32,40.86,59.42,38.75,62.02,38.75L62.02,38.75z M104.93,46.08c2.59,0,4.69,2.1,4.69,4.69c0,2.59-2.1,4.69-4.69,4.69 c-2.59,0-4.69-2.1-4.69-4.69C100.24,48.18,102.34,46.08,104.93,46.08L104.93,46.08z M56.67,61.65h10.69c0.15,0,0.27,0.12,0.27,0.27 v9.55c0,0.15-0.12,0.27-0.27,0.27H56.67c-0.15,0-0.27-0.12-0.27-0.27v-9.55C56.4,61.78,56.52,61.65,56.67,61.65L56.67,61.65z M17.95,46.08c2.59,0,4.69,2.1,4.69,4.69c0,2.59-2.1,4.69-4.69,4.69c-2.59,0-4.69-2.1-4.69-4.69 C13.25,48.18,15.36,46.08,17.95,46.08L17.95,46.08z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.214b92ffce54c49346c7b1a5c6e0655d.svg";
export { ForwardRef as ReactComponent };